import * as React from 'react'
import useResizeObserver from '@react-hook/resize-observer'

const useSize = target => {
  const [size, setSize] = React.useState({})

  React.useLayoutEffect(() => {
    setSize(target.current && target.current.getBoundingClientRect())
    //eslint-disable-next-line
  }, [target.current])

  useResizeObserver(target, entry => setSize(entry.contentRect))
  return size
}
export default useSize
